export type ActiveBtnVariant = 'secondary' | 'primary';

export enum ProfilesShownBreakPoints {
  Desktop = 200,
  Tablet = 201,
  // it is the same as Desktop
  // Mobile = 200,
  Default = Desktop,
}
